<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <UserListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import UserListing from "@/views/pages/admin/user/userListing";

export default {
    page: {
        title: i18n.t("module.user"),
    },
    components: { Layout, PageHeader, UserListing },
    data() {
        return {
            title: i18n.t("module.user"),
            items: [
                {
                    text: i18n.t("module.administration"),
                    href: '/administrations',
                },
                {
                    text: i18n.t("module.user"),
                    active: true,
                },
            ],
        };
    },
}
</script>
